import { type ReactNode } from 'react';
import { CatLoadingIndicator } from 'components/blocks-components';
import cx from 'classnames';

import styles from './equipment-loader.module.scss';

type EquipmentLoaderType = {
  children: ReactNode;
};

const EquipmentLoader = ({ children }: EquipmentLoaderType) => {
  return (
    <>
      <div
        data-testid="equipment-loader"
        className={cx(
          'd-flex justify-content-center position-absolute w-100 h-100 top-0 bottom-0',
          styles['overlay']
        )}
      >
        <CatLoadingIndicator
          className={cx('position-absolute', styles['overlay__spinner'])}
        />
      </div>
      {children}
    </>
  );
};

export default EquipmentLoader;
